(() => {
  const formatPrice = (cents) => {
    if (cents === 0) return window.theme.strings.free;
    const format = window.theme.settings.currency_code_enable ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
    return window.theme.formatMoney(cents, format);
  };

  const promoPrice = (cents, percent) => cents - Math.round((cents * percent) / 100);

  customElements.whenDefined('product-info').then(() => {
    const proto = customElements.get('product-info').prototype;
    const { setProductState, updateProductPrices } = proto;

    if (proto.promoPricingApplied) return;
    proto.promoPricingApplied = true;

    proto.setProductState = function (variant) {
      const state = setProductState.call(this, variant);
      if (variant && variant.price > 0 && this.querySelector('[data-product-price][data-promo-percent]')) {
        state.onSale = true;
      }
      return state;
    };

    proto.updateProductPrices = function (variant) {
      updateProductPrices.call(this, variant);

      const current = variant || this.getSelectedVariant(this);
      if (!current || !current.price) return;

      this.querySelectorAll('[data-price-wrapper]').forEach((wrapper) => {
        const priceElement = wrapper.querySelector('[data-product-price][data-promo-percent]');
        const compareElement = wrapper.querySelector('[data-compare-price]');
        if (!priceElement || !compareElement) return;

        const percent = Number(priceElement.dataset.promoPercent);
        const quantity = wrapper.hasAttribute('data-atc-button') ? parseInt(this.quantityInput?.value || '1', 10) || 1 : 1;
        const original = Math.max(current.compare_at_price || 0, current.price);

        priceElement.innerHTML = formatPrice(promoPrice(current.price, percent) * quantity);
        compareElement.innerHTML = formatPrice(original * quantity);
        compareElement.classList.remove('hidden');
        priceElement.classList.add('product__price--sale');
      });
    };

    document.querySelectorAll('product-info').forEach((productInfo) => productInfo.updateProductPrices());
  });
})();
